/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  CreateSessionMutationRequest,
  CreateSessionMutationResponse,
  CreateSession400,
  CreateSession401,
  CreateSession403,
} from '../types/CreateSession.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getCreateSessionUrl() {
  const res = { method: 'POST', url: `/sessions` as const };
  return res;
}

/**
 * @summary Create session
 * {@link /sessions}
 */
export async function createSession(
  data: CreateSessionMutationRequest,
  config: Partial<RequestConfig<CreateSessionMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    CreateSessionMutationResponse,
    ResponseErrorConfig<CreateSession400 | CreateSession401 | CreateSession403>,
    CreateSessionMutationRequest
  >({ method: 'POST', url: getCreateSessionUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
